import React, { useEffect, useContext, useState } from "react";
import styled from "styled-components";

import { useLocation, useNavigate } from "react-router-dom";

import style from "../../style/HospitalAddBody.module.scss";
import { AuthContext } from "../../contexts/AuthContext";
import { TagPicker } from "rsuite";
import { useForm } from "react-hook-form";
import apiClient from "../../libraries/ApiClient";
import { useQuery } from "react-query";
import { styled as styles, alpha } from "@mui/material/styles";
import {
  TextField,
  Radio,
  RadioGroup,
  FormGroup,
  Checkbox,
  FormControlLabel,
  FormControl,
  MenuItem,
  FormLabel,
  Button,
  Autocomplete,
} from "@mui/material";
import { tr } from "date-fns/locale";
import { LoginContext } from "../../contexts/LoginContext";

const CssTextField = styles((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
      },
      "&.Mui-error": {
        borderColor: "#D92920",
        color: "#EB4D3D",
      },
    },
  })
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: calc(100% - 50px);
  color: #252525;
  position: relative;
  h1 {
    line-height: 20px;
  }
  .search {
    width: 100%;
    .searchTop {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      position: relative;
      .left {
        display: flex;
        .otherCondition {
          width: 120px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border: 1px solid #f2f2f2;
          border-radius: 5px;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .right {
        .searchBtn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 120px;
        }
      }
    }
    .searchBottom {
      border: 1px solid #f2f2f2;
      background-color: #f2f2f2;
      width: 100%;
      padding: 8px;
      border-radius: 5px;
      display: ${({ isOpen }) => (isOpen ? `flex` : `none`)};
      position: absolute;
      z-index: 1;
      flex-direction: column;
      .top {
        display: flex;
        justify-content: space-between;
        .basicInformation {
          width: 49%;
        }
        .caseStatus {
          width: 49%;
        }
      }
    }
  }
  .pagination {
    height: 100px;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    position: absolute;
    bottom: 0px;
  }
  .table {
    width: 100%;
    max-height: calc(100% - 246px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

function HospitalAddBody({ Mode, rowId, setSendHospitalData }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  const [AccountId, setAccountId] = useState("");
  const { myAuth } = useContext(AuthContext);
  const isLoginAtAdmin = myAuth.IsAdmin;
  const isLoginAtPermission = myAuth.AccountPermission;

  const [Code, setCode] = useState("");
  const [Name, setName] = useState("");
  const [FullName, setFullName] = useState("");
  const [EnglishName, setEnglishName] = useState("");
  const [Prefix, setPrefix] = useState("");
  const [isHospitalCenter, setHospitalCenter] = useState(false);
  const [Status, setStatus] = useState(1);

  //錯誤判斷
  const [CodeError, setCodeError] = useState(false);
  const [NameError, setNameError] = useState(false);
  const [FullNameError, setFullNameError] = useState(false);
  const [EnglishNameError, setEnglishNameError] = useState(false);
  const [PrefixError, setPrefixError] = useState(false);
  const [isHospitalCenterError, setHospitalCenterError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
  }, []);

  //查詢機構資料
  const getHospitalDetail = async ({ queryKey }) => {
    const data = {
      Data: {
        RowId: rowId,
      },
    };

    const res = await apiClient.postAes(
      "api/Organization/Detail/Security",
      data
    );
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };

  const { getValues, control, setValue } = useForm({
    defaultValues: {
      Identities: [],
    },
  });

  const { data, refetch, isLoading } = useQuery(
    ["getHospitalDetail", rowId, token],
    getHospitalDetail,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (Mode === "Edit") {
      // console.log(data?.Data);
      setCode(data?.Data?.Code);
      setName(data?.Data?.Name);
      setFullName(data?.Data?.FullName);
      setEnglishName(data?.Data?.EngName);
      setPrefix(data?.Data?.Prefix);
      setHospitalCenter(data?.Data?.IsHospitalCenter === "true" ? true : false);
      setStatus(+data?.Data?.Status);
    }
  }, [data]);

  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };

  const handleCodeBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setCodeError(true);
    } else {
      setCodeError(false);
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleNameBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setNameError(true);
    } else {
      setNameError(false);
    }
  };

  const handleFullNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handleFullNameBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setFullNameError(true);
    } else {
      setFullNameError(false);
    }
  };

  const handleEnglishNameChange = (e) => {
    setEnglishName(e.target.value);
  };

  const handleEnglishNameBlur = (e) => {
    // const input = e.target.value;
    // if (input === "") {
    //   setEnglishNameError(true);
    // } else {
    //   setEnglishNameError(false);
    // }
  };

  const handlePrefixChange = (e) => {
    setPrefix(e.target.value);
  };

  const handlePrefixBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setPrefixError(true);
    } else {
      setPrefixError(false);
    }
  };

  const handleHospitalCenterChange = (e) => {
    setHospitalCenter(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const sendHospitalDataModel = {
    Code: Code,
    Name: Name,
    FullName: FullName,
    EngName: EnglishName,
    Prefix: Prefix,
    IsHospitalCenter: isHospitalCenter,
    Status: Status,
    RowId: rowId,
  };

  useEffect(() => {
    setSendHospitalData(sendHospitalDataModel);
  }, [Code, Name, FullName, EnglishName, Prefix, isHospitalCenter, Status]);

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <div className={style.container}>
      <div className={style.top_container}>
        <div className={style.sub_container}>
          <blockquote className={style.blockquote}>
            <div className={style.title}>合作機構資料</div>
          </blockquote>
        </div>
        <ul className={style.textInfo}>
          <li>
            新增編輯時機構代碼、機構中文名稱、選單顯示中文名稱及選單顯示英文名稱為必填
          </li>
          <li>新增機構代碼後無法修改</li>
          <li>機構代碼、選單顯示英文名稱不可重複</li>
        </ul>
        <div className={style.fist_line}>
          <div className={style.hospital_box}>
            <CssTextField
              label="機構代碼"
              variant="filled"
              value={Code || ""}
              error={CodeError}
              onBlur={handleCodeBlur}
              onChange={handleCodeChange}
              style={{ width: "100%" }}
              disabled={Mode === "Edit"}
            />
          </div>
          <div className={style.hospital_box}>
            <CssTextField
              label="機構中文名稱"
              variant="filled"
              value={FullName || ""}
              error={FullNameError}
              onBlur={handleFullNameBlur}
              onChange={handleFullNameChange}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.identity_box}>
            <CssTextField
              label="機構英文名稱"
              variant="filled"
              value={EnglishName || ""}
              error={EnglishNameError}
              onBlur={handleEnglishNameBlur}
              onChange={handleEnglishNameChange}
              style={{ width: "100%" }}
            />
          </div>
        </div>
        <div className={style.second_line}>
          <div className={style.identity_box}>
            <CssTextField
              label="選單顯示中文名稱"
              variant="filled"
              value={Name || ""}
              error={NameError}
              onBlur={handleNameBlur}
              onChange={handleNameChange}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.identity_box}>
            <CssTextField
              label="選單顯示英文名稱"
              variant="filled"
              value={Prefix || ""}
              error={PrefixError}
              onBlur={handlePrefixBlur}
              onChange={handlePrefixChange}
              style={{ width: "100%" }}
            />
          </div>
          <div className={style.identity_box}></div>
        </div>
        <div className={style.third_line}>
          <div className={style.identity_box}>
            <FormControl fullWidth error={isHospitalCenterError}>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                是否為醫學中心
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleHospitalCenterChange}
                value={isHospitalCenter}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio size="small" />}
                  label="是"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio size="small" />}
                  label="否"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className={style.identity_box}>
            <FormControl fullWidth error={statusError}>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                啟用/停用 機構
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleStatusChange}
                value={Status}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="啟用"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="停用"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className={style.identity_box}></div>
        </div>
      </div>
    </div>
  );
}

export default HospitalAddBody;
